export enum invitationCodeStatus {
  active = "active",
  used = "used",
  expired = "expired",
}
